import React from 'react';
import { useMsal } from '@azure/msal-react';
import { apiScopes } from './msalConfig';

export default function SignInButton({ className, style, children = 'Sign in' }) {
  const { instance } = useMsal();
  const handleClick = () => {
    instance.loginRedirect({ scopes: apiScopes }).catch((e) => {
      console.error('Sign-in failed', e);
    });
  };
  return (
    <button className={className || 'btn-primary'} style={style} onClick={handleClick}>
      {children}
    </button>
  );
}

export function SignOutButton({ className, style }) {
  const { instance } = useMsal();
  const handleClick = () => {
    try { localStorage.removeItem('saara_active_tenant'); } catch { /* ignore */ }
    instance.logoutRedirect();
  };
  return (
    <button className={className || 'btn-secondary'} style={style} onClick={handleClick}>
      Sign out
    </button>
  );
}
